import React from 'react';
import classnames from 'classnames';
import styles from './FloIconMenu.module.css';
import { Dropdown } from 'react-bootstrap';
import { FloComponentProps, FloMenuButtonItemType } from 'components';

export interface FloIconMenuItem {
  id:           string;
  title:        string;
  type?:        FloMenuButtonItemType;
  onClick?:     (id: string) => void;
  disabled?:    boolean;
}

export interface FloIconMenuProps extends FloComponentProps {
  menuItems:    FloIconMenuItem[];
  horizontal?:  boolean;
}

export const FloIconMenu: React.FC<FloIconMenuProps> = React.memo(({
  className,
  name = 'action-dropdown-icon',
  menuItems,
  horizontal,
}) => {

  return (
    <Dropdown className = {classnames(styles.root, className)} drop="down">
      <Dropdown.Toggle className={styles.button} id={name} >
        { horizontal ?
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.5 15C7.60457 15 8.5 14.1046 8.5 13C8.5 11.8954 7.60457 11 6.5 11C5.39543 11 4.5 11.8954 4.5 13C4.5 14.1046 5.39543 15 6.5 15ZM12.5 15C13.6046 15 14.5 14.1046 14.5 13C14.5 11.8954 13.6046 11 12.5 11C11.3954 11 10.5 11.8954 10.5 13C10.5 14.1046 11.3954 15 12.5 15ZM20.5 13C20.5 14.1046 19.6046 15 18.5 15C17.3954 15 16.5 14.1046 16.5 13C16.5 11.8954 17.3954 11 18.5 11C19.6046 11 20.5 11.8954 20.5 13Z" fill="#909CA5"/>
          </svg>
          :
          <svg width="5" height="19" viewBox="0 0 5 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5ZM5 9.5C5 10.8807 3.88071 12 2.5 12C1.11929 12 0 10.8807 0 9.5C0 8.11929 1.11929 7 2.5 7C3.88071 7 5 8.11929 5 9.5ZM5 16.5C5 17.8807 3.88071 19 2.5 19C1.11929 19 0 17.8807 0 16.5C0 15.1193 1.11929 14 2.5 14C3.88071 14 5 15.1193 5 16.5Z" fill="#9DADB9"/>
          </svg>
        }
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menu}>
        {
          menuItems.map((item, index) => (
            item.type === FloMenuButtonItemType.DIVIDER ?
              <Dropdown.Divider key={`dropdown-item-${name}-divider-${index}`}/>
            :
            <Dropdown.Item
              key={`dropdown-item-${name}-${item.id}`}
              onClick={() => item.onClick ? item.onClick(item.id) : {}}
              className={styles.item}
              disabled={item.disabled}
            >
              <div className={classnames(styles.title, {[styles.itemDisabled]: item.disabled})}>{item.title}</div>
            </Dropdown.Item>
          ))
        }
      </Dropdown.Menu>
    </Dropdown>
  );
})

export default FloIconMenu;
